var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative cursor-pointer w-10 h-10"},[_c('div',{staticClass:"center",class:[_vm.toggle ? 'active' : '', ("is-" + _vm.color)],on:{"click":function($event){return _vm.$emit('toggle', !_vm.toggle)}}},[_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }